import { Stack } from "@mui/material";

export interface ITextFieldFormHelperTextProps {
  helper?: string;
  error?: string;
}

export const TextFieldFormHelperText = ({ helper = "", error = "" }: ITextFieldFormHelperTextProps) => {
  return (
    <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
      <div>{error}</div>
      <div>{helper}</div>
    </Stack>
  );
};
